import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './loginasmodal.scss'

// import components
import Modal from '../../components/Modal'
import PinCodeModal from '../PinCodeModal'

// Actions
import { loginAs, getAuthResources } from '../../../actions/auth'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// Elements
import Button from '../../elements/button'

import { ModalIcons } from '../../elements/icons'

class LoginAsModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      isLoading: false,
      showPinModal: false,
      selectedUser: null
    }
    this.renderEmployee = this.renderEmployee.bind(this)
    this.loginAs = this.loginAs.bind(this)
    this.checkPinCode = this.checkPinCode.bind(this)
    this.closePinModal = this.closePinModal.bind(this)
  }

  loginAs (id) {
    this.setState({isLoading: true}, () => {
      this.props.loginAs(id).then((res) => {
        this.props.getAuthResources().then((res) => {
          res.data.permissions = res.data.Permissions
          if (typeof this.props.data.type !== 'undefined') {
            switch (this.props.data.type) {
              case 'inspection':
                if (hasSubscriptionPermission(res.data, 10, 30)) {
                  this.props.router.push('/orders/' + this.props.data.id + '/orderinspection')
                } else {
                  this.props.onClose(true, this.props.data)
                }
                break
              case 'workcard':
                this.props.router.push('/orders/' + this.props.data.id)
                break
            }
          }
        }).finally(() => {
          this.props.onClose(true, this.props.data)
          this.setState({isLoading: false})
        })
      }, (err) => {
        this.setState({isLoading: false})
        console.log(err)
        console.log('Nooooo, could not login', err.response.data)
      })
    })
  }

  renderEmployee (val, key) {
    if (val.Active) {
      return (
        <Button key={key} disabled={this.state.isLoading} style='link' /* onClick={this.loginAs.bind(this, val.UserId)} */ onClick={this.checkPinCode.bind(this, val)} labelText={val.Name} onLogin={this.loginAs} />
      )
    }
  }

  checkPinCode (user) {
    this.setState({
      showPinModal: true,
      selectedUser: user,
      isLoading: true
    })
  }

  closePinModal (e) {
    this.setState({
      showPinModal: false,
      isLoading: false
    }, () => {
      if (e === undefined) {
        this.props.onClose(true, this.props.data)
      }
    })
  }

  render () {
    let { employees } = this.props
    if (this.state.showPinModal) {
      return (
        <PinCodeModal router={this.props.router}
          show={this.state.showPinModal}
          onClose={this.closePinModal}
          user={this.state.selectedUser}
          data={this.props.data}
          />
      )
    }
    return (
      <div className='loginas_modal'>
        <Modal {...this.props} header={translation('57')} overflowHidden={this.state.overflowHidden}
          icon={ModalIcons.Employees_White}>
          <div className='employees'>
            {employees.map(this.renderEmployee)}
          </div>
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  loginAs,
  getAuthResources
})(LoginAsModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/LoginAsModal/index.js